module.exports = __webpack_public_path__ + "statics/img/1-7.2a5d73a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/1-7.png
// module id = KGMO
// module chunks = 1